import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { EnvironmentService } from 'src/app/service/environment.service';

@Component({
  selector: 'app-okendo',
  imports: [NgClass],
  templateUrl: './okendo.component.html',
  styleUrls: ['./okendo.component.scss'],
})
export class OkendoComponent implements AfterViewInit {
  @Input() product: any;
  @Input() _uid: string = '';
  @Input() component: string = '';
  @Input() _editable: string = '';

  count: any;
  stars: any;
  rating: any;
  @ViewChild('widget') widgetContainer!: ElementRef;

  constructor(private environmentService: EnvironmentService) {}

  ngAfterViewInit() {
    if (this.environmentService.isBrowser()) {
      setTimeout(() => {
        try {
          const okendo = JSON.parse(this.product.metafields.okendo.summaryData);
          this.count = okendo.reviewCount;
          this.rating = okendo.reviewAverageValue;
          this.stars = new Array(
            Math.floor(parseFloat(okendo.reviewAverageValue))
          );
        } catch (e) {
          console.log(e);
        }
        setTimeout(() => {
          const window = this.environmentService.getWindow();
          if (window && (window! as any).okeWidgetApi) {
            (window! as any).okeWidgetApi.initWidget(
              this.widgetContainer.nativeElement
            );
          }
        }, 300);
      }, 1000);
    }
  }
}
